var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('v-btn',{staticClass:"nav-btn",attrs:{"height":"100%","color":"transparent","depressed":""},on:{"click":_vm.login}},[_vm._v("Anmelden")]),_c('unvergessen-login-dialog',{attrs:{"dialog":_vm.dialog,"persistent":false},on:{"dialog":function($event){_vm.dialog = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }